import { PaymentMethod } from '@/@types/generated'
import { register } from './enum'

export const PaymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.CREDIT_CARD]: 'Credit Card',
  [PaymentMethod.ACH]: 'ACH Payment',
  [PaymentMethod.AGO_PAYMENT]: 'AGO Payment',
  [PaymentMethod.WH_OFFSET]: 'WH Offset',
  [PaymentMethod.FINANCE_JV]: 'Finance JV',
  [PaymentMethod.TRANSMITTAL]: 'Transmittal',
}

export const PaymentMethodDescriptions: Record<PaymentMethod, string> = {
  [PaymentMethod.CREDIT_CARD]: 'Pay with your credit card',
  [PaymentMethod.ACH]: 'Pay with Automated Clearing House',
  [PaymentMethod.AGO_PAYMENT]: 'Attorney General Office',
  [PaymentMethod.WH_OFFSET]: 'Warrant Hold',
  [PaymentMethod.FINANCE_JV]: 'Journal Voucher',
  [PaymentMethod.TRANSMITTAL]: 'Cash Room Payment',
}

register<PaymentMethod>(PaymentMethod, (v) => {
  if (!v) return '\u2014'
  return PaymentMethodLabels[v]
})
